'use client';

import clsx from 'clsx';
import { useEffect, useRef, useState } from 'react';

const StoryContent = props => {
  const { content } = props;

  const contentRef = useRef(null);
  const [showFullContent, setShowFullContent] = useState(false);
  const [showSeeMore, setShowSeeMore] = useState(false);

  useEffect(() => {
    const contentNode = contentRef.current;

    if (!contentNode) return;

    const range = document.createRange();
    range.setStart(contentNode, 0);
    range.setEnd(contentNode, contentNode.childNodes.length);
    let rangeWidth = range.getBoundingClientRect().width;
    let rangeHeight = range.getBoundingClientRect().height;
    const offsetWidth = rangeWidth - Math.floor(rangeWidth);

    if (offsetWidth < 0.001) {
      rangeWidth = Math.floor(rangeWidth);
    }

    const offsetHeight = rangeHeight - Math.floor(rangeHeight);

    if (offsetHeight < 0.001) {
      rangeHeight = Math.floor(rangeHeight);
    }

    const { top, left, right, bottom } = getPadding(contentNode);
    const horizontalPadding = left + right;
    const verticalPadding = top + bottom;

    if (
      rangeWidth + horizontalPadding > contentNode.offsetWidth ||
      rangeHeight + verticalPadding > contentNode.offsetHeight ||
      contentNode.scrollWidth > contentNode.offsetWidth
    ) {
      setShowSeeMore(true);
    }
  }, []);

  return (
    <div className='mt-2.5 lg_mt-11'>
      <div
        className={clsx(
          ' max-w-[750px] text-[14px] leading-[1.4] lg_text-[17px] lg_leading-5',
          showFullContent
            ? ''
            : 'overflow-hidden [-webkit-box-orient:vertical] [-webkit-line-clamp:8] [display:-webkit-box] lg_overflow-auto lg_[-webkit-box-orient:unset] lg_[-webkit-line-clamp:unset] lg_[display:unset]',
        )}
        ref={contentRef}
      >
        {content}
      </div>

      <button
        className={clsx('flex-none text-[15px] leading-5 text-80583F underline lg_hidden', !showSeeMore && 'invisible')}
        type='button'
        onClick={() => {
          setShowFullContent(x => !x);
        }}
      >
        {showFullContent ? 'See Less' : 'See More'}
      </button>
    </div>
  );
};

const getPadding = el => {
  const style = window.getComputedStyle(el, null);
  const paddingLeft = Number.parseInt(style.paddingLeft, 10) || 0;
  const paddingRight = Number.parseInt(style.paddingRight, 10) || 0;
  const paddingTop = Number.parseInt(style.paddingTop, 10) || 0;
  const paddingBottom = Number.parseInt(style.paddingBottom, 10) || 0;
  return {
    left: paddingLeft,
    right: paddingRight,
    top: paddingTop,
    bottom: paddingBottom,
  };
};

export default StoryContent;
